module.exports = __webpack_public_path__ + "static/media/No_Messages.06640103.png";